<template>
  <div class="message_details">
    <div class="information">
      <div class="title">留言信息</div>
      <div class="content">
        <div>
          <span class="name">咨询用户：</span>
          <span class="price">{{message.queristName}}</span>
          <span class="view" v-if="!contractNameShow" @click="viewName">查看</span>
        </div>
        <div>
          <span class="name">咨询对象：</span>
          <span class="price">{{message.advisoryObject}}</span>
        </div>
        <div>
          <span class="name">留言时间：</span>
          <span class="price">{{message.advisoryTime}}</span>
        </div>
        <div>
          <span class="name">联系方式：</span>
          <span class="price">{{message.phone}}</span>
          <span class="view" v-if="!contractPhoneShow" @click="viewPhone">查看</span>
        </div>
        <div>
          <span class="name">QQ微信：&nbsp;&nbsp;</span>
          <span class="price">{{message.qqWechat}}</span>
        </div>
        <div>
          <span class="name">咨询内容：</span>
          <span class="price">{{message.queryContent}}</span>
        </div>
      </div>
    </div>
    <div class="information">
      <div class="title">处理记录</div>
      <div class="content" v-for="(item,index) in handle" :key="index">
        <div>
          <span class="name">处理时间：</span>
          <span class="price">{{item.operateTime}}</span>
        </div>
        <div>
          <span class="name">处理人：&nbsp;&nbsp;</span>
          <span class="price">{{item.operatorName}}</span>
        </div>
        <div>
          <span class="name">处理结果：</span>
          <span class="price">{{item.content}}</span>
        </div>
      </div>
    </div>
    <div class="foot" v-if="isSupervision !== 'supervision'">
        <button @click="$router.push({path: '/investment/messageHandle',query:{id:message.id}})">留言处理</button>
    </div>
  </div>
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        name: 'messageDetails',
        components: {},
        props: {},
        data () {
            return {
                request: {
                    id: null,
                    desensitizedFlag: true
                },
                message: {
                    id: null,
                    advisoryObject: null,
                    queristName: null,
                    phone: null,
                    advisoryTime: null,
                    statue: null,
                    statueValue: null,
                    operatorName: null,
                    qqWechat: null,
                    queryContent: null
                },
                contractPhoneShow: false, // 联系电话显示
                contractNameShow: false, // 用户名显示
                handle: []
            };
        },
        computed: {
            id () {
                return this.$route.query.id;
            },
            isSupervision () {
                return localStorage.getItem('attractRole')
            }
        },
        watch: {},
        created () {
            this.setInvestmentTitle('留言详情');
            this.request.id = this.id;
            this.setInvestmentMessageDetails(this.request)
                .then(res => {
                    if (res) {
                        this.message = res;
                    }
                })
                .catch(res => {});
            this.getInvestmentMessageDealList({
                messageId: this.id
            })
                .then(res => {
                    if (res) {
                        this.handle = res.records;
                    }
                })
                .catch(res => {});
        },
        methods: {
            ...mapActions('investment', [
                'setInvestmentTitle',
                'setInvestmentMessageDetails',
                'getInvestmentMessageDealList'
            ]),
            // 查看号码
            viewPhone () {
                this.request.desensitizedFlag = false;
                this.setInvestmentMessageDetails(this.request)
                    .then(res => {
                        if (res) {
                            this.message.phone = res.phone;
                            this.contractPhoneShow = true;
                        }
                    })
                    .catch(res => {});
            },
            // 查看用户名
            viewName () {
                this.request.desensitizedFlag = false;
                this.setInvestmentMessageDetails(this.request)
                    .then(res => {
                        if (res) {
                            this.message.queristName = res.queristName;
                            this.contractNameShow = true;
                        }
                    })
                    .catch(res => {});
            }
        },

        mounted () {}
    };
</script>

<style lang="less" scoped>
.message_details {
  min-height: 100%;
  font-family: PingFangSC-Regular;
  padding: 12px 12px 108px;
  background: #f5f6f9;
  .information {
    background: #ffffff;
    padding: 12px 20px 0;
    margin-bottom: 12px;
    border-radius: 3px;
    .title {
      color: #333333;
      font-size: 16px;
      line-height: 22px;
      font-weight: bold;
      padding-bottom: 12px;
    }
    .content {
      border-top: 0.5px solid #eeeeee;
      color: #333333;
      font-size: 12px;
      line-height: 17px;
      padding-bottom: 12px;
      div {
        padding-top: 12px;
        display: flex;
        justify-content: flex-start;
        word-break: break-all;

        .name {
          white-space: nowrap;
          margin-right: 8px;
        }

        .view {
          color: #36b374;
          margin-left: 5px;
        }
      }
    }
  }
  .foot {
    position: fixed;
    bottom: 0;
    left: 0;
    bottom: 0;
    padding: 13px 12px 47px;
    background: #ffffff;
    width: 100%;
    button {
      border: 0;
      background: #36b374;
      display: block;
      width: 100%;
      padding: 13px;
      line-height: 22px;
      font-size: 16px;
      color: #ffffff;
      border-radius: 3px;
    }
  }
}
</style>
